import { useParams, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "../api/axiosInstance";
import "./PharmacistPricingPage.css";

export default function PharmacistPricingPage() {
  const { requestId } = useParams();
  const navigate = useNavigate();
const [pricePreview, setPricePreview] = useState(null);
const [isSubmitting, setIsSubmitting] = useState(false);

  const [price, setPrice] = useState("");
  const [days, setDays] = useState("Same Day");
  const [bill, setBill] = useState(null);
  const [preview, setPreview] = useState(null);

  const [requestDetail, setRequestDetail] = useState(null);

  // 🔹 FETCH EXISTING PRICE (SAME VIEW YOU MENTIONED)
  useEffect(() => {
    axios
      .get(`/availability-request/${requestId}/`)
      .then((res) => {
        setRequestDetail(res.data);

        // auto-fill if already priced
        if (res.data.base_price) {
          setPrice(res.data.base_price);
        }
        if (res.data.days) {
          setDays(res.data.days);
        }
      })
      .catch(() => {
        alert("Unable to load request details");
      });
  }, [requestId]);
useEffect(() => {
  if (!price) {
    setPricePreview(null);
    return;
  }

  console.log("🔥 Preview API calling with price:", price);

  const timeout = setTimeout(() => {
    axios
      .post("/pharmacist/pricing-preview/", { price })
      .then((res) => {
        console.log("✅ Preview response:", res.data);
        setPricePreview(res.data);
      })
      .catch((err) => {
        console.error("❌ Preview error:", err.response?.data || err);
        setPricePreview(null);
      });
  }, 400);

  return () => clearTimeout(timeout);
}, [price]);


  const submitPricing = async () => {
  if (isSubmitting || requestDetail.status === "priced") return;
    const form = new FormData();
    if (price) form.append("price", price);
    if (days) form.append("days", days);
    if (bill) form.append("bill", bill);

    if (!price && !bill) {
      alert("Please enter price or upload receipt");
      return;
    }

    try {
    setIsSubmitting(true);
      await axios.post(`/pharmacist/pricing/${requestId}/`, form);
      alert("Pricing sent to user");
      navigate("/pharmacist/rx-dashboard", { replace: true });

    } catch (err) {
  console.error("❌ FULL ERROR:", err);

  const msg =
    err?.response?.data?.error ||
    err?.response?.data?.message ||
    "Server error - try again";

  alert(msg);

  setIsSubmitting(false);
}
  };

  const handleBillChange = (e) => {
    const file = e.target.files[0];
    setBill(file);
    if (file) setPreview(URL.createObjectURL(file));
  };

  if (!requestDetail) return <p>Loading...</p>;

  return (
    <div className="pricing-page">
      <div className="pricing-card">

        <h2 className="title">💊 Medicine Pricing</h2>
        <p className="sub">
          Request ID: <strong>#{requestId}</strong>
        </p>

        {/* 🔹 PRICE INFO (READ ONLY) */}
        {requestDetail.base_price && (
          <div className="info-box">
            <p><strong>Price Set:</strong> ₹{requestDetail.base_price}</p>
            {requestDetail.days && (
              <p><strong>Delivery Time:</strong> {requestDetail.days}</p>
            )}
            <p className="status">
              Status: <strong>{requestDetail.status}</strong>
            </p>
          </div>
        )}
{requestDetail.medicine_days && (
  <p>
    🧪 Medicine Required For:{" "}
    <b>{requestDetail.medicine_days} days</b>
  </p>
)}

        {/* MANUAL PRICING */}
        <div className="section">
          <h4>Manual Pricing</h4>


          <input
            className="input"
            placeholder="Total Price (₹)"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
          />

          <input
            className="input"
            placeholder="Delivery time (e.g. 2 days)"
            value={days}
            onChange={(e) => setDays(e.target.value)}
          />


        </div>

        

        {/* BILL UPLOAD */}
        <div className="section">
          <h4>Upload Bill / Receipt</h4>

          <label className="upload-box">
            📷 Upload Image
            <input
              type="file"
              accept="image/*"
              hidden
              onChange={handleBillChange}
            />
          </label>

          {preview && (
            <div className="preview">
              <img src={preview} alt="Bill Preview" />
            </div>
          )}
<div className="section">
  <h4>Manual Pricing</h4>
{pricePreview && (
  <div className="info-box">
    <p>
      <b>Entered Price:</b> ₹{pricePreview.base_price}
    </p>



    <p style={{ color: "green", fontWeight: "bold" }}>
      💰 You will receive: ₹{pricePreview.hospital_amount}
    </p>
  </div>
)}


          <button
  className="primary-btn"
  onClick={submitPricing}
  disabled={isSubmitting || requestDetail.status === "priced"}
>
  {isSubmitting ? "Submitting..." : "Send Price to User"}
</button>
        

        </div>
</div>
      </div>
    </div>
  );
}
